import { LOADING_CIRCLE } from "../core/loading/LoadingCircle";
import { useContext } from "react";
import { AuthContext } from "../../context/context.authentication";
import { Link, useNavigate } from "react-router-dom";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { fetchLogin } from "../../fetch/fetch.authentication";
import {
  IconKeyOff,
  IconLockOpen,
  IconLogin2,
  IconUserPlus,
} from "@tabler/icons-react";
import { AUTH_STATE, ROUTE_AUTH, ROUTE_REGISTER } from "../../const/routes";
import { useSubmitState } from "../../hooks/useSubmitState";
import { isError } from "../../types/Result";
import { closeEveryModal } from "../core/PopUp";
import { ERROR_ICON } from "../../types/Error/ErrorIcons.tsx";
import { ERROR, ERROR_TEXT, ErrorType } from "../../types/Error/Errors.ts";
import { LoginType } from "../../types/Login.ts";
import EmailInput from "../auth/input/EmailInput.tsx";
import PasswordInput from "../auth/input/PasswordInput.tsx";

const initButton = (
  <>
    <IconLogin2 />
    Anmelden
  </>
);
const loadingButton = (
  <>
    {LOADING_CIRCLE}
    Anmelden
  </>
);
const successButton = (
  <>
    <IconLockOpen />
    Du bist jetzt eingeloggt
  </>
);
const errorButton = (error: ErrorType) => {
  console.log(error);
  return (
    <>
      {ERROR_ICON[error]}
      {ERROR_TEXT[error]}
    </>
  );
};
const LoginForm = ({ redirectTo }: { redirectTo?: string }) => {
  const { startAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  const authForm = useForm<LoginType>({
    mode: "all",
  });
  const submitState = useSubmitState({ initButtonChild: initButton });

  const handleLogin: SubmitHandler<LoginType> = async (data) => {
    if (submitState.loading) return;
    submitState.init(loadingButton);
    const res = await fetchLogin(data.email, data.password);
    if (isError(res)) {
      submitState.fetchFailed(res.error, errorButton(res.error));
      return;
    }
    if (!startAuth(res.value)) {
      submitState.fetchFailed(
        "Token couldn't be set.",
        errorButton(ERROR.UNDEFINED),
      );
      return;
    }
    submitState.fetchSuccess(successButton);
    closeEveryModal();
    if (redirectTo) {
      navigate(redirectTo);
    }
  };
  return (
    <div className="grid w-full">
      <form onSubmit={authForm.handleSubmit(handleLogin)}>
        <FormProvider {...authForm}>
          <fieldset className="fieldset">
            <h6 className="fieldset-legend text-lg p-2">Anmelden</h6>
            <EmailInput />
            <PasswordInput autoComplete={"current-password"} />
            <button
              className="btn btn-primary w-full"
              disabled={submitState.loading}
            >
              {submitState.buttonChild}
            </button>
          </fieldset>
        </FormProvider>
      </form>

      <div className="grid grid-cols-2 gap-1 items-center ">
        <span className="grow justify-self-end">Noch nicht dabei?</span>
        <Link className="btn btn-sm btn-accent" to={ROUTE_REGISTER}>
          <IconUserPlus />
          Registrieren
        </Link>
        <span className="grow justify-self-end">Passwort vergessen?</span>
        <Link
          className="btn btn-sm btn-neutral"
          to={ROUTE_AUTH(AUTH_STATE.reset)}
        >
          <IconKeyOff />
          Zurücksetzen
        </Link>
      </div>
    </div>
  );
};
export default LoginForm;
